import { render, staticRenderFns } from "./areaCard.vue?vue&type=template&id=63e7062a&"
import script from "./areaCard.vue?vue&type=script&lang=js&"
export * from "./areaCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports